/** Roles that may open quiz previews. Previews never create attempts but can show answer keys, so students and parents are kept out. */
export const STAFF_PREVIEW_ROLES = ["master_admin", "admin", "center_manager", "tutor", "state_partner", "growth_partner"];

export const canOpenPreview = (role: string | null | undefined) => !!role && STAFF_PREVIEW_ROLES.includes(role);
